module.exports = __webpack_public_path__ + "static/media/game_quest_desktop_es.0cddd3a3.png";